import { Utils, convertTa } from '../charts-lib'

export function getInitChartConfig() {
  window.globalChartConfig.scrollable = false
  if (FinvizSettings.hasUserPremium) {
    window.globalChartConfig.scrollable = window.globalChartConfig.editable || !Utils.isMobile()
  }

  if (FinvizSettings.TA) {
    const COTs = FinvizSettings.COTs
    convertTa.mergeChartAndTAConfig(window.globalChartConfig, FinvizSettings.TA, COTs ? { COTs } : undefined)
  }

  return window.globalChartConfig
}
